function initCartNoteCollapsible(){
  l = document.querySelector('.cartnote label');
  n = document.getElementById('CartNoteDrawer');
  l.addEventListener('click',function(e){
    if(l.classList.contains('is-open')){l.classList.remove('is-open');n.classList.add('hide');}
    else{l.classList.add('is-open');n.classList.remove('hide');}
  });

}


document.addEventListener('DOMContentLoaded', function() {
  //initCartNoteCollapsible();
  initValuePackPurchase();

  document.addEventListener('ajaxProduct:added', function(evt){
   // console.log(evt);
    if(evt.detail != null){
       if(evt.detail.product != null){
         //console.log('^%$ '+evt.detail.product.final_line_price/100);
         rubix('conv', 'order', evt.detail.product.final_line_price/100);
       } 
    }
  });
});



// document.addEventListener("variant:change", function (v) {
//   if( v.detail.variant != null){
//     var pos = $('[data-imgid='+ v.detail.variant.featured_media.id +'].product-main-slide').position();
//     //console.log(v.detail.variant.featured_media.id);
//         if($('.product-slideshow').css('flex-wrap') == 'nowrap')
//         {
//           $(".product-slideshow").animate({scrollLeft: pos.left},300)
//         }
// //     else {
// //       if($('.modal__centered-content').is(":visible")){$('.modal__centered-content').animate({scrollTop: pos.top},300);}
// //       else { $('html,body').animate({scrollTop: pos.top + 200},300) }
// //     }
//   }
// });

document.addEventListener('limespot:addedToCart', (event) => {
    var items = event.detail.items;
    
//     console.log("limespot:addedToCart");
//     console.log(items);
  	document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
});


function initValuePackPurchase(){
  if(document.getElementById('pkAddToCart') != null){
      document.querySelectorAll('.pk_types_selector').forEach(function(l){
        l.addEventListener('click',function(e){
          var c = document.querySelector('input[name="Color"]:checked').value;
          if(c != undefined){
            document.getElementById('pkAddToCart').classList.add('hide');
            document.querySelectorAll('.hide .pk_opts_selector').forEach(function(l){l.checked=false;});
            document.querySelectorAll('.valuepkoptset').forEach(function(l){l.classList.add('hide');});
            document.getElementById('valuepl-'+c).classList.remove('hide');
          }
        });
      });

      document.querySelectorAll('.pk_opts_selector').forEach(function(l){
        l.addEventListener('click', function(e){
          document.querySelectorAll('.hide .pk_opts_selector').forEach(function(l){l.checked=false;});
          if(document.querySelectorAll('.pk_opts_selector:checked').length >= 1){
            document.getElementById('pkAddToCart').classList.remove('hide');
          } else {
            document.getElementById('pkAddToCart').classList.add('hide');
          }
        });  
      });

      document.getElementById('pkAddToCart').addEventListener('click',function(f){
        var ids = "";
        document.querySelectorAll('.pk_opts_selector:checked').forEach(function(i){ids = "&id[]="+i.value +ids});
        console.log(ids);
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: "quantity=1"+ids,
    //       body: "properties[value pack]=yes&quantity=1"+ids,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            alert(data.description);
          } else {
            console.log('done atc')
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        });



      });
  }
}

class VideoElement extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.init();
  }

  init() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.loadVideo();
      observer.unobserve(this);
    }

    // Set an IntersectionObserver to check if the video is nearly in the viewport
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }

  loadVideo() {
    this.video.childNodes.forEach((source) => {
      if (typeof source.tagName === "string" && source.tagName === "SOURCE") {
        source.src = source.dataset.src;
      }
    })

    this.video.load();
    this.video.classList.remove("lazy");
  }
}

customElements.define('video-element', VideoElement);

class ToolTipTriggerClicker extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.trigger = this.dataset.toolTip;
    this.init();
  }

  init() {
    this.el.addEventListener('click', e => {
      e.stopPropagation();
      const trigger = document.querySelector(`[data-tool-tip="${this.trigger}"]`);
      if (trigger) {
        trigger.click();
      }
    });
  }
}
  
customElements.define('tool-tip-trigger-clicker', ToolTipTriggerClicker);

class NavigationSection extends HTMLElement {
  constructor() {
    super();
    this.config = {
      showImages: this.dataset.showImages == "true",
      enableSticky: this.dataset.enableSticky == "true",
    };

    this.elements = {
      imagesSliderContainer: this.querySelector('[data-images-slider-container]'),
      imagesSlider: this.querySelector('[data-images-slider]'),
      linksSliderContainer: this.querySelector('[data-links-slider-container]'),
      linksSlider: this.querySelector('[data-links-slider]'),
    }

    theme.navigationSections.push(this);
  }

  connectedCallback() {
    if (this.elements.linksSlider) {
      const linksSliderChildrenArray = Array.from(this.elements.linksSlider.children);
      const activeLinksSliderChild = this.elements.linksSlider.querySelector('[data-active="true"]');

      const linksSliderInitialIndex = activeLinksSliderChild ? linksSliderChildrenArray.indexOf(activeLinksSliderChild) : 0;


      const linksSliderOptions = {
        adaptiveHeight: false,
        initialIndex: linksSliderInitialIndex,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        freeScroll: true,
        draggable: true,
        contain: true,
        resize: true,
        cellAlign: 'left',
      }

      this.linksSliderFlickity = new theme.Slideshow(this.elements.linksSlider, linksSliderOptions);
    }

    if (this.elements.imagesSlider) {
      const imagesSliderChildrenArray = Array.from(this.elements.imagesSlider.children);
      const activeimagesSliderChild = this.elements.imagesSlider.querySelector('[data-active="true"]');

      const imagesSliderInitialIndex = activeimagesSliderChild ? imagesSliderChildrenArray.indexOf(activeimagesSliderChild) : 0;


      const imagesSliderOptions = {
        adaptiveHeight: false,
        initialIndex: imagesSliderInitialIndex,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        freeScroll: true,
        draggable: true,
        contain: true,
        resize: true,
        cellAlign: 'left',
      }

      this.imagesSliderFlickity = new theme.Slideshow(this.elements.imagesSlider, imagesSliderOptions);
    }

    if (this.config.enableSticky) {
      if (this.config.showImages) {
        this.adjustStickyLinksSliderVisibility();
        window.addEventListener('scroll', this.adjustStickyLinksSliderVisibility.bind(this));
      }

      this.calculatePreviousNavigationSectionsHeight();
      window.addEventListener('resize', this.calculatePreviousNavigationSectionsHeight.bind(this));
    }
  }

  calculatePreviousNavigationSectionsHeight() {
    let previousNavigationSectionsHeight = 0;
    let _this = this;
    for (const navigationSection of theme.navigationSections) {
      if (_this == navigationSection) break;
      const linksSliderContainer = navigationSection.querySelector('[data-links-slider-container]');
      if (navigationSection.config.enableSticky && linksSliderContainer) {
        previousNavigationSectionsHeight += linksSliderContainer.offsetHeight;
      }
    }
    
    this.style.setProperty('--previous-navigation-sections-height', previousNavigationSectionsHeight + 'px');
  }

  adjustStickyLinksSliderVisibility() {
    const currentScroll = window.scrollY;
    const endOfSection = (this.offsetTop + this.offsetHeight) - (theme.config.stickyHeader ? document.querySelector('.site-header').offsetHeight : 0);
    if (currentScroll >= endOfSection) {
      this.dataset.stickyLinksSliderVisible = "true";
    } else {
      delete this.dataset.stickyLinksSliderVisible;
    }
  }
}

customElements.define('navigation-section', NavigationSection);